<div id="main-container-wrap">
  <div id="header-wrap">
    <a
      href="https://3ddigitalvenue.com"
      target="_blank"
      class="ms-auto me-auto"
    >
      <img src="assets/img/logo.png" alt="" />
    </a>
  </div>
  <div id="content-wrap">
    <div class="modal">
      <div class="row">
        <div class="modal-col">
          <div class="text-container">
            <h1>Nothing here</h1>
            <p>
              The page you requested was not found. If you type the URL
              directly, please make sure the spelling is correct. If you clicked
              on a link to get here, probably the link is outdated or we changed
              the name of that direction.
            </p>
          </div>
          <div class="button-container">
            <a href="https://3ddigitalvenue.com" target="_blank">GO HOME</a>
          </div>
        </div>
        <div class="modal-col">
          <div class="img-container">
            <img style="width: 200px" src="assets/img/notfound.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="footer-wrap">
    <div>
      <span>MMC</span>
      <img src="assets/img/copyright.png" alt="" />
      <span>{{ year }}</span>
    </div>
    <div>
      <a href="https://3ddigitalvenue.com/legal/cookies-policy" target="_blank"
        >Cookies Policy</a
      >
    </div>
    <div>
      <a href="https://3ddigitalvenue.com/legal/privacy-policy" target="_blank"
        >Privacy Policy</a
      >
    </div>
  </div>
</div>
